import { useId as s } from "react";
const i = (r, e) => {
  const o = `${r}-trigger`, a = `${r}-panel`;
  return {
    triggerProps: {
      id: o,
      "aria-expanded": e,
      "aria-controls": a
    },
    panelProps: {
      id: a,
      role: "region",
      "aria-labelledby": o,
      "aria-hidden": !e
    }
  };
}, n = (r) => i(s(), r);
export {
  i as getDisclosureProps,
  n as useDisclosure
};
